import type { NextApiRequest, NextApiResponse } from 'next';
import { CACHE_HOST, CACHE_PORT } from '../helpers/cluster';
import Redis from 'ioredis';
import uuid from './uuid';

export const TRACKING_SESSION_ID_NAME = 'trackingSessionId';
const TRACKING_SESSION_TTL_MINUTES = 30;

export default class TrackingSession {
    private readonly redis: Redis;

    public constructor() {
        this.redis = new Redis(CACHE_PORT, CACHE_HOST);
    }

    public async init(
        req: NextApiRequest,
        res: NextApiResponse,
    ): Promise<void> {
        let trackingSessionId: string | undefined | null =
            req.cookies[TRACKING_SESSION_ID_NAME];

        const deviceId = req.cookies.deviceId;

        const redisKey = deviceId
            ? `${ TRACKING_SESSION_ID_NAME }:${ deviceId }`
            : undefined;

        const redis = this.redis;

        if (trackingSessionId) {
            if (redisKey) {
                await redis.del(redisKey);
            }
        } else {
            if (redisKey) {
                trackingSessionId = await redis.get(redisKey);

                if (!trackingSessionId) {
                    trackingSessionId = uuid();
                    redis.set(
                        redisKey,
                        trackingSessionId,
                        'EX',
                        TRACKING_SESSION_TTL_MINUTES * 60,
                    );
                }
            } else {
                trackingSessionId = uuid();
            }

            req.cookies[TRACKING_SESSION_ID_NAME] = trackingSessionId;
            req.headers.cookie = `${
                req.headers.cookie || ''
            }; ${
                TRACKING_SESSION_ID_NAME
            }=${
                trackingSessionId
            }`;
        }

        const expires = new Date(
            Date.now() +
            TRACKING_SESSION_TTL_MINUTES * 60 * 1000,
        ).toUTCString();

        res.appendHeader(
            'Set-Cookie',
            `${
                TRACKING_SESSION_ID_NAME
            }=${
                trackingSessionId
            }; Path=/; Expires=${
                expires
            }; HttpOnly`,
        );
    }
}

const scope: {trackingSession?: TrackingSession} = (
    typeof window === 'undefined' ? global : window
) as any;

if (!scope.trackingSession) {
    scope.trackingSession = new TrackingSession();
}

const trackingSession = scope.trackingSession;

export { trackingSession };
